module.exports = __webpack_public_path__ + "img/Mock.36190ddc.png";